// extracted by mini-css-extract-plugin
export default {"modelDetailParameterList":"c-f_eK"};